const RecoverPasswordInitialValues = {
    password: '',
    passwordRepeat: '',
    actualPassword: ''
}

export default RecoverPasswordInitialValues